import { render, staticRenderFns } from "./ServicesApproval.vue?vue&type=template&id=48db67c4&"
import script from "./ServicesApproval.vue?vue&type=script&lang=js&"
export * from "./ServicesApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports